import { Divider, Grid, Paper, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { moneyWithDots } from '../../Utils/Format/MoneyFormat';
import SelectInput from '../../Components/Inputs/SelectInput';
import { history } from '../../Routes/history';
import { ROUTE_NAMES } from '../../Routes/Routes';
import { Company } from '../../Configs/general';
import Skeleton from '@material-ui/lab/Skeleton';

const LoadingState = ({ classes }) => (
  <Paper variant="outlined" className={classes.container}>
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
    >
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <SelectInput
              fullWidth
              label="Proyecto"
              disabled={true}
              options={[]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectInput fullWidth label="Etapa" disabled={true} options={[]} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12} sm="auto">
        <Typography className={classes.subtitle}>Plan comercial</Typography>
        <Skeleton variant="text" />
      </Grid>

      <Grid item xs={12} sm="auto">
        <Typography className={classes.subtitle}>Valor total</Typography>
        <Skeleton variant="text" />
      </Grid>

      <Grid item xs={12} sm="auto">
        <Typography className={classes.subtitle}>
          {Company.contractConjugation.capitalized.plural.main} activos
        </Typography>
        <Skeleton variant="text" />
      </Grid>
    </Grid>
  </Paper>
);

const ConstructorPhaseHeader = ({
  phase,
  projects,
  selectedProject,
  setSelectedProject,
  phases,
  selectedPhase,
  isLoading,
  classes
}) => {
  const activeContractsPercentage = useMemo(() => {
    if (!phase) {
      return '-';
    }

    return Math.floor((phase.activeContracts / phase.units) * 100);
  }, [phase]);

  const handleProjectChange = event => {
    setSelectedProject(event.target.value);
  };

  const handlePhaseChange = event => {
    const phaseContractId = event.target.value;
    history.push(`${ROUTE_NAMES.constructorPhase}/${phaseContractId}`);
  };

  if (isLoading) {
    return <LoadingState classes={classes} />;
  }

  return (
    <Paper variant="outlined" className={classes.container}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <SelectInput
                fullWidth
                label="Proyecto"
                disabled={isLoading}
                options={projects}
                onChange={handleProjectChange}
                value={selectedProject}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SelectInput
                fullWidth
                label="Etapa"
                disabled={isLoading}
                options={phases}
                onChange={handlePhaseChange}
                value={selectedPhase}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12} sm="auto">
          <Typography className={classes.subtitle}>Plan comercial</Typography>
          <Typography className={classes.text}>
            {(phase &&
              phase.quotationData &&
              phase.quotationData.commercialPlanName) ||
              ''}
          </Typography>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Typography className={classes.subtitle}>Valor total</Typography>
          <Typography className={classes.text}>
            {moneyWithDots(
              (phase &&
                phase.quotationData &&
                phase.quotationData.totalValue) ||
                ''
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Typography className={classes.subtitle}>
            {Company.contractConjugation.capitalized.plural.main} activos
          </Typography>
          <Typography className={classes.text}>
            {activeContractsPercentage}% (
            {(phase && phase.activeContracts) || 0}/
            {(phase && phase.units) || 0})
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ConstructorPhaseHeader;
